/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StateOrAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CheckOut from './CheckOut/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function StateOrAction({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Checkout/Appointments/Content/Appointment/StateOrAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedIsHoveredValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'is_hovered',
})
let appointmentBookingStateValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'state',
})
let aggregateData = fromHelpers.getView(selectedIsHoveredValueData, appointmentBookingStateValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckOut'}>
<CheckOut
  viewPath={`${viewPath}/CheckOut`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}